import { Button } from "antd";
import K from "utilities/constants";
import { isPermissionPresent } from "utilities/generalUtility";
import { Link } from "react-router-dom";
import { DefaultColumnOptions } from "../../../hooks/useDataGrid/options";
import { EditIconButton } from "../../../common/components/iconButton/editIconButton";

const actionColumnRenderer = (userRoles) => (params) => (
  <>
    {params.data.isDefault ? (
      <Button type="link" className="text-primary-light" disabled>
        Default
      </Button>
    ) : (
      isPermissionPresent(K.Permissions.EditRolesAndPermissions, userRoles) && (
        <Link to={`/configurations/roles-permission/edit/${params.data.id}`}>
          <EditIconButton />
        </Link>
      )
    )}
  </>
);

export const getColumns = (userRoles) => [
  DefaultColumnOptions.Id,
  {
    headerName: "Role Name",
    field: "displayName",
    sortable: true,
    sort: "asc",
    tooltipComponent: "displayName",
  },
  {
    ...DefaultColumnOptions.Actions,
    hide: !isPermissionPresent(K.Permissions.EditRolesAndPermissions, userRoles),
    cellRenderer: actionColumnRenderer(userRoles),
  },
];
